export default {"src":"/_next/static/media/hofBanner.3b1b1f34.svg","height":404,"width":1296};